import type { CSSProperties } from "react"
import { css } from "styled-components"

/** ScrollView / FlatList 占满父级 flex 剩余空间（H5 flex 布局下可滚动） */
export const scrollViewFillStyle: CSSProperties = {
  flex: 1,
  minHeight: 0,
  width: "100%",
}

export function scrollContentStyle(extra?: CSSProperties): CSSProperties {
  return { flexGrow: 0, ...extra }
}

/** 页面根级 flex 容器：子级 ScrollView 需配合 scrollViewFillStyle */
export const flexPageContainer = css`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`
